import { PAYMENT, PAYMENT_WITH_PLAN } from './schema/payment'
import { CAREER } from './schema/career'
import { PERSON } from './schema/person'
import { FORM } from './schema/form'
import { SYSTEM } from './schema/system'

export const updatePayment = /* GraphQL */ `
  mutation UpdatePayment(
    $input: UpdatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    updatePayment(input: $input, condition: $condition) ${PAYMENT}
  }
`

export const createPayment = /* GraphQL */ `
  mutation CreatePayment(
    $input: CreatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    createPayment(input: $input, condition: $condition) ${PAYMENT}
  }
`

export const updateCareer = /* GraphQL */ `
  mutation UpdateCareer(
    $input: UpdateCareerInput!
    $condition: ModelCareerConditionInput
  ) {
    updateCareer(input: $input, condition: $condition) ${CAREER}
  }
`

export const createCareer = /* GraphQL */ `
  mutation CreateCareer(
    $input: CreateCareerInput!
    $condition: ModelCareerConditionInput
  ) {
    createCareer(input: $input, condition: $condition) ${CAREER}
  }
`

export const updateCareerAnalyse = /* GraphQL */ `
  mutation UpdateCareerAnalyse(
    $input: UpdateCareerAnalyseInput!
    $condition: ModelCareerAnalyseConditionInput
  ) {
    updateCareerAnalyse(input: $input, condition: $condition) {
      id
      input
      diagnostic_version
      preset
      time_needed
      verified
      status
      career_id
      partner_id
      language
      person_id
      person {
        authorized
        id
        owner
        language
        invitation_firstname
        firstname
        invitation_lastname
        lastname
        invitation_email
        phone
        postcode
        city
        email
        space {
          authorized
          diagnostic_version
          id
          owner
          os
          additional_requested_data
          language
          partner_id
          invited_from_user_id
          favored_by_user_id
          context
          createdAt
          updatedAt
          soft_deleted
          lastUpdatedBy
          last_seen
          authorized_create
          authorized_read
          authorized_update
          authorized_delete
          application_status
          universal_app_meta
          callback_url
          expiresAt
          created_with_service
          invitation_reminder_at
          reset_expiredAt_at
          career_id
          partner_user_id
          ref_link
          referrer_link
          matching_score_to_space_career
          related_spaces
          all_challenges_unlocked
          newsletter
          invitation_via
          progress
          mail_stored
          invitation_id
          authorization_roles
          customer_dashboard_meta
          __typename
        }
        createdAt
        updatedAt
        lastUpdatedBy
        partner_id
        authorized_create
        authorized_read
        authorized_update
        authorized_delete
        personSpaceId
        __typename
      }
      url_params
      invited_from_user_id
      total_time_needed_in_min
      comment {
        person_id
        owner
        message
        createdAt
        __typename
      }
      createdAt
      updatedAt
      lastUpdatedBy
      copy_from_careeranalyse_id
      copy_from_careeranalyse_career_id
      authorized_create
      authorized_read
      authorized_update
      authorized_delete
      __typename
    }
  }
`

export const createCareerAnalyse = /* GraphQL */ `
  mutation CreateCareerAnalyse(
    $input: CreateCareerAnalyseInput!
    $condition: ModelCareerAnalyseConditionInput
  ) {
    createCareerAnalyse(input: $input, condition: $condition) {
      id
      input
      diagnostic_version
      preset
      time_needed
      verified
      status
      career_id
      partner_id
      language
      person_id
      person {
        authorized
        id
        owner
        language
        invitation_firstname
        firstname
        invitation_lastname
        lastname
        invitation_email
        phone
        postcode
        city
        email
        createdAt
        updatedAt
        lastUpdatedBy
        partner_id
        authorized_create
        authorized_read
        authorized_update
        authorized_delete
        personSpaceId
        __typename
      }
      url_params
      invited_from_user_id
      total_time_needed_in_min
      comment {
        person_id
        owner
        message
        createdAt
        __typename
      }
      createdAt
      updatedAt
      lastUpdatedBy
      copy_from_careeranalyse_id
      copy_from_careeranalyse_career_id
      authorized_create
      authorized_read
      authorized_update
      authorized_delete
      __typename
    }
  }
`

export const createPerson = /* GraphQL */ `
  mutation CreatePerson(
    $input: CreatePersonInput!
    $condition: ModelPersonConditionInput
  ) {
    createPerson(input: $input, condition: $condition) ${PERSON}
  }
`

export const updatePerson = /* GraphQL */ `
  mutation UpdatePerson(
    $input: UpdatePersonInput!
    $condition: ModelPersonConditionInput
  ) {
    updatePerson(input: $input, condition: $condition) ${PERSON}
  }
`

export const updateForm = /* GraphQL */ `
  mutation UpdateForm(
    $input: UpdateFormInput!
    $condition: ModelFormConditionInput
  ) {
    updateForm(input: $input, condition: $condition) ${FORM}
  }
`

export const createForm = /* GraphQL */ `
  mutation CreateForm(
    $input: CreateFormInput!
    $condition: ModelFormConditionInput
  ) {
    createForm(input: $input, condition: $condition) {
      id
      form_source
      createdAt
    }
  }
`

export const updateSpace = /* GraphQL */ `
  mutation UpdateSpace(
    $input: UpdateSpaceInput!
    $condition: ModelSpaceConditionInput
  ) {
    updateSpace(input: $input, condition: $condition) {
      id
      authorized
      partner_id
      career_id
      created_by_partner_id
      authorized_create
      authorized_read
      authorized_update
      authorized_delete
      application_status
      lastUpdatedBy
      updatedAt
      __typename
    }
  }
`

// FEATURE_FLAGS (Experimente). updateSystem immer mit condition auf updatedAt,
// damit eine parallele Änderung des Evaluators nicht überschrieben wird.
export const createSystem = /* GraphQL */ `
  mutation CreateSystem(
    $input: CreateSystemInput!
    $condition: ModelSystemConditionInput
  ) {
    createSystem(input: $input, condition: $condition) ${SYSTEM}
  }
`

export const updateSystem = /* GraphQL */ `
  mutation UpdateSystem(
    $input: UpdateSystemInput!
    $condition: ModelSystemConditionInput
  ) {
    updateSystem(input: $input, condition: $condition) ${SYSTEM}
  }
`

// Nächster Termin der täglichen Experiment-Auswertung. Nur die id wird
// gebraucht.
export const createCronTTL = /* GraphQL */ `
  mutation CreateCronTTL(
    $input: CreateCronTTLInput!
    $condition: ModelCronTTLConditionInput
  ) {
    createCronTTL(input: $input, condition: $condition) {
      id
    }
  }
`

// Payments mit plan. mutation() in src/api/index.js liest data[<Exportname>],
// deshalb Aliase auf createPayment und updatePayment. Nur verwenden, wenn die
// Schema-Probe Payment.plan meldet, sonst lehnt AppSync das Input-Feld plan ab.
export const createPaymentWithPlan = /* GraphQL */ `
  mutation CreatePaymentWithPlan(
    $input: CreatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    createPaymentWithPlan: createPayment(input: $input, condition: $condition) ${PAYMENT_WITH_PLAN}
  }
`

export const updatePaymentWithPlan = /* GraphQL */ `
  mutation UpdatePaymentWithPlan(
    $input: UpdatePaymentInput!
    $condition: ModelPaymentConditionInput
  ) {
    updatePaymentWithPlan: updatePayment(input: $input, condition: $condition) ${PAYMENT_WITH_PLAN}
  }
`
